<script setup>
import { servizioPage } from '@/graphql/queries/servizi.js'

definePageMeta({
  layout: 'default',
})

const route = useRoute()
const slug = route.params.slug

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
  slug,
}))

const { data } = await useGraphql(servizioPage, variables)

const page = computed(() => data?.value?.listaServizi || {})
const seo = computed(() => page?.value?.seo || {})
useSeo(seo)
</script>

<template>
  <div class="page page-servizio p-top-1a">
    <p v-if="page.titolo" class="intro-page-title text-3 row-400-20 max">
      {{ page.titolo }}
    </p>
    <template v-if="page.body && page.body.length">
      <section v-for="item in page.body" :key="item.id">
        <template v-if="item.__typename === 'IntroPagineRecord'">
          <IntroPagine :intro="item" />
        </template>
        <template v-if="item.__typename === 'PrimoBloccoContenutiRecord'">
          <PrimoBloccoContenuti :blocco="item" />
        </template>
        <template v-if="item.__typename === 'BloccoImmagineTesto1Record'">
          <ImageText :blocco="item" />
        </template>
      </section>
    </template>
    <OverlapBlock
      v-if="page.bloccoSovrapposto"
      :blocco-sovrapposto="page.bloccoSovrapposto"
      type="type1"
    />
    <EndPageSection
      v-if="page.ambitiDiIntervento && page.testoBloccoSettori"
      :ambiti="page.ambitiDiIntervento"
      :settori-text="page.testoBloccoSettori"
      :servizio-suggerito="page.servizioSuggerito"
      class="black-bg"
    />
  </div>
</template>
